export default {
    deepCopy: params => {
        if (params) {
            return JSON.parse(JSON.stringify(params))
        }
    },
    formatTime(time) {
        let s = time % 60;
        let h = Math.floor(time / (60 * 60))
        let m = Math.floor((time - h * 60 * 60) / 60)
        if (h) {
            return h + '小时' + m + '分钟' + s + '秒'
        }
        if (m) {
            return m + '分钟' + s + '秒'
        }
        if (s) {
            return s + '秒'
        }
    },
    time0(time) {
        var time = Number(time)
        time > 9 ? '' : time = '0' + time;
        return time;
    },
    getMonth() {
        var date = new Date();
        var y = date.getFullYear();

        var m = date.getMonth() + 1;
        m > 9 ? '' : m = '0' + m;

        return y + '' + m
    },
    debounce(fn, wait) {
        var timeout = null;
        return function() {
            if (timeout !== null) {
                clearTimeout(timeout);
            };
            timeout = setTimeout(fn, wait);
        }
    },
    plat: function() { //应用设备类型判断
        var u = navigator.userAgent;
        // console.log(u)
        if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) { //android终端
            return 0;
        } else if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) { //ios终端
            return 1;
        } else {
            return 2; //pc
        }
    },


}


// WEBPACK FOOTER //
// ./src/assets/js/func.js